
    export const LISTITEMS: any[] = [
        {"url":"/page", "name":"Page", "icon":"ft-home"},
        {"url":"/pages/login", "name":"Login", "icon":"ft-log-in"},
        {"url":"/pages/forgotpassword", "name":"Forgot Password", "icon":"ft-alert-octagon"},
        {"url":"/pages/securitycode", "name":"Security Code", "icon":"ft-alert-octagon"},
        {"url":"/pages/changepassword", "name":"Change Password", "icon":"ft-alert-octagon"},
    ]

